module.exports = __webpack_public_path__ + "img/logo.b364330f.png";